import React from 'react';
import logoInstagram from '../assets/logo-instagram.svg';
import logoWhatsapp from '../assets/logo-whatsapp.svg';

/** Tautan share Google Maps — buka di aplikasi / browser */
const CLINIC_GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/sywwXVMugvg6sWCAA';
/** Embed (tanpa API key): koordinat mengikuti titik di tautan di atas */
const CLINIC_MAP_EMBED_SRC =
  'https://www.google.com/maps?q=Praktek+Drg.+Desfa+Sandra,+Payakumbuh&hl=id&z=16&output=embed';

export function ClinicContact() {
  return (
    <section id="kontak">
      <div className="max-w-7xl">
        <div className="text-center clinic-section-header">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 clinic-section-title">
            Informasi Kontak
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto clinic-section-desc">
            Hubungi atau kunjungi klinik kami
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          {/* Contact Info */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-14 h-14 bg-sky-100">
                <span style={{ fontSize: '1.25rem' }}>📍</span>
              </div>
              <h3 style={{ fontWeight: 700, color: '#1f2937', marginTop: '0.5rem', marginBottom: '0.25rem', fontSize: '0.875rem' }}>
                Alamat
              </h3>
              <p style={{ color: '#6b7280', fontSize: '0.8125rem', margin: 0 }}>
                Jl. Jendral Sudirman, Balai Baru, Koto Nan Gadang, Payakumbuh Utara, Balai Baru, Kec. Payakumbuh Utara, Kota Payakumbuh
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-14 h-14 bg-sky-100">
                <span style={{ fontSize: '1.25rem' }}>📞</span>
              </div>
              <h3 style={{ fontWeight: 700, color: '#1f2937', marginTop: '0.5rem', marginBottom: '0.25rem', fontSize: '0.875rem' }}>
                Telepon
              </h3>
              <p style={{ color: '#6b7280', fontSize: '0.8125rem', margin: 0 }}>
                (0752)91517
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-14 h-14 bg-sky-100">
                <span style={{ fontSize: '1.25rem' }}>✉️</span>
              </div>
              <h3 style={{ fontWeight: 700, color: '#1f2937', marginTop: '0.5rem', marginBottom: '0.25rem', fontSize: '0.875rem' }}>
                Email
              </h3>
              <p style={{ color: '#6b7280', fontSize: '0.8125rem', margin: 0 }}>
                <a href="mailto:[EMAIL_ADDRESS]" style={{ color: '#0284c7', textDecoration: 'none' }}>
                  klinikgigidesfasandra@gmail.com
                </a>
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-14 h-14 bg-sky-100">
                <span style={{ fontSize: '1.25rem' }}>
                  <img src={logoInstagram} alt="Instagram" style={{ width: '1.25rem', height: '1.25rem', display: 'block' }} />
                </span>
              </div>
              <h3 style={{ fontWeight: 700, color: '#1f2937', marginTop: '0.5rem', marginBottom: '0.25rem', fontSize: '0.875rem' }}>
                Instagram
              </h3>
              <p style={{ color: '#6b7280', fontSize: '0.8125rem', margin: 0 }}>
                <a href="https://instagram.com/eklinikgigi" target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', textDecoration: 'none' }}>
                  @eklinikgigi
                </a>
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-14 h-14 bg-sky-100">
                <span style={{ fontSize: '1.25rem' }}>
                  <img src={logoWhatsapp} alt="WhatsApp" style={{ width: '1.25rem', height: '1.25rem', display: 'block' }} />
                </span>
              </div>
              <h3 style={{ fontWeight: 700, color: '#1f2937', marginTop: '0.5rem', marginBottom: '0.25rem', fontSize: '0.875rem' }}>
                WhatsApp
              </h3>
              <p style={{ color: '#6b7280', fontSize: '0.8125rem', margin: 0 }}>
                <a href="https://wa.me/62812345678" target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', textDecoration: 'none' }}>
                  0812345678
                </a>
              </p>
            </div>
          </div>

          {/* Peta lokasi (Google Maps) */}
          <div className="h-full min-h-[300px] flex flex-col gap-2">
            <div
              className="flex-1 min-h-[280px] bg-gray-200 shadow-lg overflow-hidden"
              style={{ borderRadius: '0.85rem' }}
            >
              <iframe
                title="Peta lokasi klinik di Google Maps"
                src={CLINIC_MAP_EMBED_SRC}
                width="100%"
                height="100%"
                style={{ minHeight: '280px', border: 0, display: 'block' }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
            <a
              href={CLINIC_GOOGLE_MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: '#0284c7',
                textAlign: 'center',
                textDecoration: 'none',
              }}
            >
              Buka di Google Maps →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ClinicContact;
